import { render, staticRenderFns } from "./SPBGReport.vue?vue&type=template&id=6fe1ae3c"
import script from "./SPBGReport.vue?vue&type=script&lang=js"
export * from "./SPBGReport.vue?vue&type=script&lang=js"
import style0 from "./SPBGReport.vue?vue&type=style&index=0&id=6fe1ae3c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports